import * as React from 'react';
import { DataGrid } from '@mui/x-data-grid';

const columns = [
    //{ field: 'id', headerName: '', width: 70, hide: true }, //removed extra column
    { field: 'label', width: 300, headerName: 'Select All' }, //disableColumnMenu:true
];

const AllFilterKey = "ALL";

export default function DataTable(props) {

    const { data, propKey } = props;

    const selectedCustomerAssests = (assests) => {

        const selectedIDs = new Set(assests);
        const nonRepeatedRow = new Set(data?.map((ele) => ele?.id));
        const selectedRows = data?.filter((row) =>
            selectedIDs.has(row.id),
        );
        const selectedAssests = nonRepeatedRow?.size === selectedIDs?.size ? AllFilterKey : selectedRows;
        propKey(selectedAssests)
    }

    return (
        <div style={{ height: 400, width: '100%' }}>
            <DataGrid
                rows={data}
                columns={columns}
                pageSize={5}
                rowsPerPageOptions={[5]}
                checkboxSelection
                GridLines="None"
                onSelectionModelChange={(assests) => {selectedCustomerAssests(assests)}}
            />
        </div>
    );
}
